import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAuthStore from '../stores/authStore';
import useUserSettingsStore from '../stores/userSettingsStore';
import useDocumentStore from '../stores/documentStore';
import RegistrationPromptModal from './RegistrationPromptModal'; // Импортируем новый компонент
import './DocumentSummary.css'; // Импортируем стили

const DocumentSummary = ({ summary, documentId }) => {
  const { t } = useTranslation();
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isRegistrationPromptOpen, setIsRegistrationPromptOpen] = useState(false);
  const { isAuthenticated } = useAuthStore();
  const { openSettings } = useUserSettingsStore();
  const documentResult = useDocumentStore(state => state.documentResult);

  const handleSettingsClick = () => {
    if (isAuthenticated) {
      openSettings();
    } else {
      setIsRegistrationPromptOpen(true);
    }
  };

  const renderKeyPoints = (content) => {
    try {
      const data = JSON.parse(content);
      return (
        <ul>
          {data.points.map((point, index) => (
            <li key={index}>
              <h4 className="docsummary__point-title">{point.title}</h4>
              <div className="docsummary__point-content">{point.content}</div>
            </li>
          ))}
        </ul>
      );
    } catch (e) {
      console.error('Failed to parse key points:', e);
      return <div className="docsummary__error">{t('documentSummary.parseError')}</div>;
    }
  };

  return (
    <div className="docsummary__container">
      <div className="docsummary__header">
        <h3 className="docsummary__title">{t('documentSummary.title')}</h3>
        <button
          className="docsummary__settings-link"
          onClick={handleSettingsClick}
        >
          {t('documentSummary.settingsLink')}
        </button>
      </div>
      <div className="docsummary__content">
        {renderKeyPoints(summary)}
      </div>
      {isRegistrationPromptOpen && (
        <RegistrationPromptModal onClose={() => setIsRegistrationPromptOpen(false)} />
      )}
    </div>
  );
};

export default DocumentSummary; 
